import { useEffect, useRef, useState } from 'react';
import { toCanonicalDecimalSeparator, toNumericValue } from './numeric-input-utils';
export const useSyncedDisplayValue = ({ sourceValue, format, regionalFormat })=>{
    const [displayValue, setDisplayValue] = useState(()=>format(sourceValue) ?? '');
    const lastSyncedSourceRef = useRef(sourceValue);
    useEffect(()=>{
        if (sourceValue === lastSyncedSourceRef.current) {
            return;
        }
        lastSyncedSourceRef.current = sourceValue;
        const isDisplayingSourceValue = toNumericValue(sourceValue) === toNumericValue(toCanonicalDecimalSeparator(displayValue, regionalFormat));
        if (isDisplayingSourceValue) {
            return;
        }
        setDisplayValue(format(sourceValue) ?? '');
    }, [
        sourceValue,
        displayValue,
        regionalFormat,
        format
    ]);
    return [
        displayValue,
        setDisplayValue
    ];
};

//# sourceMappingURL=use-synced-display-value.js.map